import script from "./VensoDelivery.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoDelivery.vue?vue&type=script&setup=true&lang=ts"

import "./VensoDelivery.vue?vue&type=style&index=0&id=2182260b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2182260b"]])

export default __exports__